export var TABLE_FILTER_LOADING = 'TABLE_FILTER_LOADING';
export var TABLE_FILTER_RECEIVE = 'TABLE_FILTER_RECEIVE';
export var TABLE_ITEMS_LOADING = 'TABLE_ITEMS_LOADING';
export var TABLE_ITEMS_RECEIVE = 'TABLE_ITEMS_RECEIVE';
export var TABLE_ITEMS_SET_PAGE_ROW = 'TABLE_ITEMS_SET_PAGE_ROW';
export var TABLE_ITEMS_UPDATED = 'TABLE_ITEMS_UPDATED';
export var TABLE_ITEMS_DELETED = 'TABLE_ITEMS_DELETED';
export var TABLE_ITEMS_PAGE_UPDATE = 'TABLE_ITEMS_PAGE_UPDATE';
export var TABLE_ITEMS_SET_FILTER = 'TABLE_ITEMS_SET_FILTER';
export var TABLE_ITEMS_SET_SEARCH_QUERY = 'TABLE_ITEMS_SET_SEARCH_QUERY';
export var TABLE_ITEMS_SORT_APPLIED = 'TABLE_ITEMS_SORT_APPLIED';
export var TABLE_ITEMS_ADDED = 'TABLE_ITEMS_ADDED';
export var TABLE_ITEMS_UPDATE_COUNT = 'TABLE_ITEMS_UPDATE_COUNT';
export var TABLE_ITEMS_CLEAR = 'TABLE_ITEMS_CLEAR';
export var TABLE_ITEMS_LOADING_ERROR = 'TABLE_ITEMS_LOADING_ERROR';
export var TABLE_ITEMS_FILTER_RECEIVE = 'TABLE_ITEMS_FILTER_RECEIVE';
export var TABLE_ITEMS_SET_ADDITIONAL_DATA = 'TABLE_ITEMS_SET_ADDITIONAL_DATA';
export var TABLE_ITEMS_SET_SCROLL_STATE = 'TABLE_ITEMS_SET_SCROLL_STATE';
export var TABLE_REMOVE_EXTRA_ITEMS = 'TABLE_REMOVE_EXTRA_ITEMS';
export var TABLE_ITEMS_CLEAR_IDS = 'TABLE_ITEMS_CLEAR_IDS';
export var TABLE_ITEMS_SET_GROUP_BY = 'TABLE_ITEMS_SET_GROUP_BY';
export var TABLE_ITEMS_CLEAR_ADDITIONAL_DATA = 'TABLE_ITEMS_CLEAR_ADDITIONAL_DATA';
export var TABLE_RESET_TO_INITIAL_STATE = 'TABLE_RESET_TO_INITIAL_STATE';
export default {
  TABLE_FILTER_LOADING: 'TABLE_FILTER_LOADING',
  TABLE_FILTER_RECEIVE: 'TABLE_FILTER_RECEIVE',
  TABLE_ITEMS_LOADING: 'TABLE_ITEMS_LOADING',
  TABLE_ITEMS_RECEIVE: 'TABLE_ITEMS_RECEIVE',
  TABLE_ITEMS_SET_PAGE_ROW: 'TABLE_ITEMS_SET_PAGE_ROW',
  TABLE_ITEMS_UPDATED: 'TABLE_ITEMS_UPDATED',
  TABLE_ITEMS_DELETED: 'TABLE_ITEMS_DELETED',
  TABLE_ITEMS_PAGE_UPDATE: 'TABLE_ITEMS_PAGE_UPDATE',
  TABLE_ITEMS_SET_FILTER: 'TABLE_ITEMS_SET_FILTER',
  TABLE_ITEMS_SET_SEARCH_QUERY: 'TABLE_ITEMS_SET_SEARCH_QUERY',
  TABLE_ITEMS_SORT_APPLIED: 'TABLE_ITEMS_SORT_APPLIED',
  TABLE_ITEMS_ADDED: 'TABLE_ITEMS_ADDED',
  TABLE_ITEMS_CLEAR: 'TABLE_ITEMS_CLEAR',
  TABLE_ITEMS_LOADING_ERROR: 'TABLE_ITEMS_LOADING_ERROR',
  TABLE_ITEMS_FILTER_RECEIVE: 'TABLE_ITEMS_FILTER_RECEIVE',
  TABLE_ITEMS_SET_ADDITIONAL_DATA: 'TABLE_ITEMS_SET_ADDITIONAL_DATA',
  TABLE_RESET_TO_INITIAL_STATE: TABLE_RESET_TO_INITIAL_STATE,
  TABLE_ITEMS_CLEAR_IDS: TABLE_ITEMS_CLEAR_IDS,
  TABLE_REMOVE_EXTRA_ITEMS: TABLE_REMOVE_EXTRA_ITEMS,
  TABLE_ITEMS_SET_GROUP_BY: TABLE_ITEMS_SET_GROUP_BY
};